import styled from '@emotion/styled';
import * as React from 'react';
import { fade_in_scale } from '../../animations';
import { Z_INDEX } from '../../vars';

export interface ImageViewWidgetProps {
  img: string;
  close: () => any;
}

export const ImageViewWidget: React.FC<ImageViewWidgetProps> = (props) => {
  return (
    <S.Container onClick={props.close}>
      <S.Image src={props.img} />
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    z-index: ${Z_INDEX.IMAGE_VIEWER};
  `;

  export const Image = styled.img`
    max-width: 90%;
    max-height: 90%;
    border: solid 1px rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    overflow: hidden;
    ${fade_in_scale}
  `;
}
